module.exports = __webpack_public_path__ + "img/20250812.6fb6353a.jpg";